import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard'),
        },
        {
          path: 'products',
          name: 'Products',
          component: () => import('@/views/Products'),
        },
        {
          path: 'products/:uid?',
          props: true,
          name: 'Product',
          component: () => import('@/views/Product'),
        },
        {
          path: 'customers',
          name: 'Customers',
          component: () => import('@/views/Customers'),
        },
        {
          path: 'customers/details/:uid',
          name: 'CustomerDetails',
          props: true,
          component: () => import('@/views/CustomerDetails'),
        },
        {
          path: 'customers/:uid?',
          name: 'Customer',
          props: true,
          component: () => import('@/views/Customer'),
        },
        {
          path: 'customers/new',
          name: 'NewCustomer',
          props: true,
          component: () => import('@/views/Customer'),
        },
        {
          path: 'orders',
          name: 'Orders',
          props: true,
          component: () => import('@/views/Orders'),
        },
        {
          path: 'orders/:uid?',
          name: 'Order',
          props: true,
          component: () => import('@/views/Order'),
        },
        {
          path: 'orders/new',
          name: 'NewOrder',
          props: true,
          component: () => import('@/views/Order'),
        },
        {
          path: 'orders/product/:productUid?',
          name: 'ProductOrder',
          props: true,
          component: () => import('@/views/Order'),
        },
        {
          path: 'orders/customer/:customerUid?',
          name: 'CustomerOrder',
          props: true,
          component: () => import('@/views/Order'),
        },
        {
          path: 'subscriptions',
          name: 'Subscriptions',
          props: true,
          component: () => import('@/views/Subscriptions'),
        },
        {
          path: 'subscriptions/:uid',
          name: 'Subscription',
          props: true,
          component: () => import('@/views/Subscription'),
        },
        {
          path: 'support',
          name: 'Support',
          props: true,
          component: () => import('@/views/Support'),
        },
        // settings area
        {
          path: 'settings/userProfile',
          name: 'UserProfile',
          props: true,
          component: () => import('@/views/Settings/UserProfile'),
        },
        {
          path: 'settings/resellerProfile',
          name: 'ResellerProfile',
          props: true,
          component: () => import('@/views/Settings/ResellerProfile'),
          meta: {
            authorizationRoles: ['OperatorAdmin', 'ResellerAdmin'],
          },
        },
        // admin area
        {
          path: 'admin/resetContext',
          name: 'ResetContext',
          props: true,
          component: () => import('@/views/Admin/ResetContext'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/resellers',
          name: 'Resellers',
          props: true,
          component: () => import('@/views/Admin/Resellers'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/resellers/edit/:resellerUid?',
          name: 'Reseller',
          props: true,
          component: () => import('@/views/Admin/Reseller'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/resellerOrders',
          name: 'ResellerOrders',
          props: true,
          component: () => import('@/views/Admin/ResellerOrders'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/manualorders',
          name: 'Manual Orders',
          props: true,
          component: () => import('@/views/Admin/ManualOrders'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/invoices',
          name: 'Invoices',
          props: true,
          component: () => import('@/views/Admin/Invoices'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/invoices/view/:invoiceUid',
          name: 'Invoice',
          props: true,
          component: () => import('@/views/Admin/Invoice'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/users',
          name: 'Users',
          props: true,
          component: () => import('@/views/Admin/Users'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/users/edit/:userUid?',
          name: 'User',
          props: true,
          component: () => import('@/views/Admin/User'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/products',
          name: 'ManageProducts',
          props: true,
          component: () => import('@/views/Admin/ManageProducts'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/products/edit/:productUid?',
          name: 'ManageProduct',
          props: true,
          component: () => import('@/views/Admin/ManageProduct'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/products/edit/:productUid/variant/:variantUid?',
          name: 'ManageProductVariant',
          props: true,
          component: () => import('@/views/Admin/ManageProductVariant'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
        {
          path: 'admin/sales',
          name: 'SalesReport',
          props: true,
          component: () => import('@/views/Admin/SalesReport'),
          meta: {
            authorizationRoles: ['OperatorAdmin'],
          },
        },
      ],
    },
    {
      path: '/callback',
      name: 'Login callback',
      component: () => import('@/views/Security/CallBack'),
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: () => import('@/views/Security/Unauthorized'),
    },
  ],
})

// secure the router based on metadata in the paths
router.beforeEach(async (to, from, next) => {
  var authenticated = false
  if (store.state.security.isAuthenticated) {
    // console.log('user authenticated');
    authenticated = true
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log('authenticating');
    // authentication is required. Trigger the sign in process, including the return URI
    store.dispatch('Authenticate', to.path).then(() => {
      if (store.state.security.isAuthenticated === true) {
        // console.log('user authenticated');
        if (checkAuthorization(to) === true) {
          next()
        }
      }
    })
  } else {
    // No auth required. We can navigate
    // console.log('no authentication needed');
    authenticated = true
  }
  if (authenticated === false) {
    return
  }
  if (checkAuthorization(to) === true) {
    next()
  }
})

function checkAuthorization (to) {
  // console.log('authorizing', to);
  if (!to.meta.authorizationRoles) {
    // console.log('No authorization required');
    return true
  } else if (
    (to.meta.authorizationRoles &&
      store.getters.userHasAccess(to.meta.authorizationRoles) === true) ||
    !to.meta.authorizationRoles
  ) {
    // console.log('authorization required and available');
    return true
  } else {
    // console.log('authorization required and unavailable');
    return false
  }
}

export default router
